import { memo } from "react";
import useOneRepMaxSourceQueryState from "components/charting/hooks/useOneRepMaxSourceQueryState/useOneRepMaxSourceQueryState";
import AddOneRepMaxDialogProvider from "../providers/AddOneRepMaxDialogProvider";
import OneRepMaxChartHeader from "../OneRepMaxChartHeader";
import { OneRepMaxChartContentBody } from "./components";
import { OneRepMaxChartContentRoot } from "./OneRepMaxChartContent.components";

function OneRepMaxChartContent() {
  const [oneRepMaxSource] = useOneRepMaxSourceQueryState();

  return (
    <AddOneRepMaxDialogProvider>
      <OneRepMaxChartContentRoot data-source={oneRepMaxSource}>
        <OneRepMaxChartHeader />
        <OneRepMaxChartContentBody />
      </OneRepMaxChartContentRoot>
    </AddOneRepMaxDialogProvider>
  );
}

export default memo(OneRepMaxChartContent);
